import * as React from "react";
import { useParams } from "react-router-dom";
import {
  ExperienceProvider,
  ExperienceContext,
} from "@origin-digital/features";
import { useAppContext, IAppContext } from "../../AppContext";
import { withErrorBoundary } from "../ErrorBoundary";
import { getOffers, getSecondaryMboxes, getMboxSlug } from "./utils";
import { SecondaryPlacement } from "./SecondaryPlacement";

const ControllerComponent = () => {
  const context: IAppContext = useAppContext();
  const routeParams = useParams();
  const mboxSlug = getMboxSlug(routeParams);
  if (!mboxSlug) {
    // Save ourselves a Target API call
    return null;
  }

  const mboxes = getSecondaryMboxes(mboxSlug, context.isNative);

  return (
    <ExperienceProvider mboxes={mboxes}>
      <ExperienceContext.Consumer>
        {({ targetOffers }) => {
          const contentForMboxes = getOffers(targetOffers, mboxes);
          return <SecondaryPlacement offers={contentForMboxes} />;
        }}
      </ExperienceContext.Consumer>
    </ExperienceProvider>
  );
};

export const SecondaryPlacementController = withErrorBoundary(
  ControllerComponent
);
